import { render, staticRenderFns } from "./PriceSourceDropdownField.vue?vue&type=template&id=32680b1b"
import script from "./PriceSourceDropdownField.vue?vue&type=script&lang=ts"
export * from "./PriceSourceDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32680b1b')) {
      api.createRecord('32680b1b', component.options)
    } else {
      api.reload('32680b1b', component.options)
    }
    module.hot.accept("./PriceSourceDropdownField.vue?vue&type=template&id=32680b1b", function () {
      api.rerender('32680b1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PriceSourceDropdownField.vue"
export default component.exports